module.exports = __webpack_public_path__ + "img/canaco.58704cf3.jpg";